import { render } from "./ReportsIndex.vue?vue&type=template&id=329b035b"
import script from "./ReportsIndex.vue?vue&type=script&lang=js"
export * from "./ReportsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__